/**
 * 假数据 - Phase 0-B UI Demo 用
 */
import type { GameResources, Idol, Group } from '../game/types'

export const mockResources: GameResources = {
  money: 128500,
  fame: 62,
  totalFans: 45800,
  reputation: 71,
  influence: 34,
  ap: 3,
  maxAp: 5,
}

export const mockIdols: Idol[] = [
  {
    id: 'idol_001',
    name: '星野 凛',
    rarity: 'SR',
    level: 15,
    exp: 3400,
    stats: { vocal: 78, dance: 65, charm: 88, stamina: 72, mental: 80 },
    status: 'active',
    skills: [],
    scandal: 5,
    fans: 18200,
    groupId: 'group_001',
    joinDate: { year: 1, month: 1, week: 1 },
    graduationRisk: false,
    relationships: {},
    portraitUrl: '',
    backstory: '来自东京的少女，梦想成为全国最闪耀的偶像。',
  },
  {
    id: 'idol_002',
    name: '月见 爱莉',
    rarity: 'R',
    level: 9,
    exp: 1200,
    stats: { vocal: 55, dance: 82, charm: 67, stamina: 60, mental: 55 },
    status: 'tired',
    skills: [],
    scandal: 12,
    fans: 9600,
    groupId: 'group_001',
    joinDate: { year: 1, month: 2, week: 3 },
    graduationRisk: false,
    relationships: {},
    portraitUrl: '',
    backstory: '舞蹈天才，但容易疲惫，需要细心照料。',
  },
  {
    id: 'idol_003',
    name: '夜空 小雪',
    rarity: 'SSR',
    level: 22,
    exp: 7800,
    stats: { vocal: 92, dance: 79, charm: 95, stamina: 85, mental: 90 },
    status: 'active',
    skills: [],
    scandal: 2,
    fans: 31500,
    groupId: null,
    joinDate: { year: 1, month: 1, week: 2 },
    graduationRisk: false,
    relationships: {},
    portraitUrl: '',
    backstory: '神秘系美少女，独自活动时人气更高。',
  },
  {
    id: 'idol_004',
    name: '花田 桃子',
    rarity: 'N',
    level: 3,
    exp: 280,
    stats: { vocal: 32, dance: 28, charm: 45, stamina: 40, mental: 38 },
    status: 'active',
    skills: [],
    scandal: 0,
    fans: 620,
    groupId: null,
    joinDate: { year: 1, month: 3, week: 1 },
    graduationRisk: true,
    relationships: {},
    portraitUrl: '',
    backstory: '刚入行的新人，潜力尚未发掘。',
  },
]

export const mockGroups: Group[] = [
  {
    id: 'group_001',
    name: 'Lunaria',
    memberIds: ['idol_001', 'idol_002'],
    style: 'mysterious',
    fame: 58,
    fans: 27800,
    chemistry: [],
    debutDate: { year: 1, month: 2, week: 4 },
  },
]

export const mockAgency = {
  name: '暗星制作',
  level: 2,
  date: { year: 1, month: 4, week: 2 },
}
